import {cookies, Notifier} from "@intermesh/goui";
import {ServerApi} from "../util/ServerApi.js";
import {CurrentItem} from "./CurrentItem.js";
import {t} from "../util/Translate.js";
import {frontendSectionDS} from "../DataSources";

export class CurrentSection extends CurrentItem {
	public static sectionId?: string;
	static storageItem = "currentSection";
	static baseRoute = "elearning/frontend/sections"

	static async readIf(sectionId?: string) {
		if (!sessionStorage.getItem(CurrentSection.storageItem)) {
			if (sectionId) {
				this.sectionId = sectionId;
				cookies.unset("sectionAuth", "/");
			} else if (cookies.get("sectionAuth")) {
				const arSec = cookies.get("sectionAuth")!.split("--");
				if (arSec.length >= 2) {
					this.sectionId = arSec[0];
				}
			}

			// if (!cookies.get("sectionAuth") || !this.sectionId) {
			if (!cookies.get("sectionAuth") && !this.sectionId) {
				return {};
			}
			try {
				const section = await frontendSectionDS.single(this.sectionId!);
				if (section) {
					sessionStorage.setItem(CurrentSection.storageItem, JSON.stringify(section));
				} else {
					Notifier.error("Unknown error loading section data", 3000);
					console.log(section);
				}
			} catch (err) {
				Notifier.error(err, 3000);
				throw (err);
			}
		}
		return CurrentSection.get();
	}

	static get() {
		return JSON.parse(sessionStorage.getItem(CurrentSection.storageItem)!);
	}

	static async load(sectionId: string) {
		CurrentSection.clear();
		this.sectionId = sectionId;
		const section = await frontendSectionDS.single(sectionId);
		if (section) {
			sessionStorage.setItem(CurrentSection.storageItem, JSON.stringify(section));
			return CurrentSection.get();
		}
		throw t("Section not found");
	}

	static clear() {
		cookies.unset("sectionAuth", "/");
		cookies.unset("useSignin", "/");
		sessionStorage.removeItem(CurrentSection.storageItem);
		delete CurrentSection.sectionId;
	}

	static async loadSectionAuth(value: string | undefined, remember: boolean, useSignin: boolean): Promise<void> {
		if (value) {
			let exp = undefined;
			// Check if the "remember" is checked.
			if (remember) {
				// this will set the expiration to 6 months
				exp = 24 * 60 * 60 * 180;
			}
			cookies.set("sectionAuth", value, exp, "/");
		}

		const cookieValue = cookies.get("sectionAuth");
		if (cookieValue) {
			const parts = cookieValue.split("--");
			if (parts[1]) {
				await this.readIf();
				if (useSignin) {
					await this.loadSigninConfig();
				}
				return Promise.resolve();
			}
		}

		return Promise.reject();
	}

	static async loadSigninConfig() {
		cookies.set("useSignin", "0", undefined, "/");
		const cs = CurrentSection.get();
		if(!cs.id) {
			throw(t("Section not found"));
		}
		const url = ServerApi.url("signin/frontend/config",{returnProperties: "*", sectionId: cs.id});
		const result = await ServerApi.call(url, {}, "GET");//.then((result: any) => {
		if(!result.success) {
			cs.signinConfig = {
				enabled: false
			};
		} else {
			cs.signinConfig = result.data; // TODO? Global signin configuration?
		}

		sessionStorage.setItem(CurrentSection.storageItem, JSON.stringify(cs));
	}

	static findLanguage() {
		const cs = CurrentSection.get();
		for (const l of cs.languages) {
			if (l.language.key === sessionStorage.getItem("language")) {
				return l;
			}
		}
	}

	static async loadByLocationCode(locationCode: string):Promise<void>   {
		const p = {
			returnProperties: "id",
			limit: 1,
			q: [['where', {"locationCode": locationCode}]]
		}
		const url = ServerApi.url(CurrentSection.baseRoute, p);

		ServerApi.call(url, {}, "GET").then(async (result) => {
			if(!result.data || !result.data.length) {
				const w = "No section found with locationCode: " + locationCode
					+ " Check if locationcode is correctly set for a section.";
				Notifier.warning(w);
				return Promise.reject(w);
			}
			await CurrentSection.load(result.data[0].id);
			return Promise.resolve();
		});
	}
}

export const currentSection = () => Object.assign(new CurrentSection());